import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_TOAST_DURATION_MS } from '../app.constants';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(
    private readonly toastController: ToastController,
    private readonly translateService: TranslateService
  ) {
    this.toastController.create({ animated: false }).then((t) => {
      t.present();
      t.dismiss();
    });
  }

  success(message: string, showIndefinitely?: boolean, duration?: number) {
    this.createToast(message, 'success', showIndefinitely, duration);
  }

  error(message: string, showIndefinitely?: boolean, duration?: number) {
    this.createToast(message, 'danger', showIndefinitely, duration);
  }

  info(message: string, showIndefinitely?: boolean, duration?: number) {
    this.createToast(message, 'secondary', showIndefinitely, duration);
  }

  private async createToast(
    text: string,
    color: string,
    showIndefinitely?: boolean,
    duration?: number
  ) {
    const message = this.translateService.instant(text);

    const toast = await this.toastController.create({
      message,
      duration: showIndefinitely ? undefined : (duration || DEFAULT_TOAST_DURATION_MS),
      cssClass: 'toast-text',
      color
    });

    toast.present();
  }
}
